import React from 'react'
import EventManagement from '../EventManagement/EventManagement'

function EventPage() {
  return (
    <div>
     <EventManagement/>
    </div>
  )
}

export default EventPage
